const Colors = {
  indigo: '#721E7F',
  darkIndigo: '#3F0F46',
  tropic: '#0F6A88',
  darkTropic: '#005065',
  fiord: '#405363',
  sunflower: '#EEDF7B',
  mojo: '#C2453F',
  selectiveYellow: '#F7B500',
  hotToddy: '#AD970A',
  mudd: '#444444',
  bittersweet: '#FF6060',
  vanilla: '#F4DDDC',
  lagoon: '#008694',
  mist: '#F4F6F7',
  alabaster: '#FAFAFA',
  fog: '#E0E4E4',
  fogAlt: '#DFE6EA',
  white: '#FFFFFF',
  aluminum: '#ABB1BD',
  martinique: '#282850',
  nevada: '#6D7278',
  dustyGray: '#979797',
  ghost: '#CED4DA',
  pewter: '#979C9C',
  skyHighlight: '#D6EFF6',
  shadeHighlight: '#E2ECEE',
  black: '#000',
  black85: 'rgba(0,0,0,.85)',
  black50: 'rgba(0,0,0,.5)',
  black25: 'rgba(0,0,0,.25)',
  black10: 'rgba(0,0,0,.1)',
  white85: 'rgba(255,255,255,.85)',
  white50: 'rgba(255,255,255,.5)',
  white25: 'rgba(255,255,255,.25)',
};

export default Colors;
